/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';

interface SideSheetArrowTypes {
  onClick: () => void;
  isSideSheetExpanded?: boolean;
}

/**
 * @SideSheetArrow
 *
 * The SideSheetArrow is a clickable button ONLY for desktop
 * that opens and closes the desktop SideSheet. The mobile SideSheet
 * has a built in button as it is a bottom sheet. @see @SideSheet
 *
 * ```typescript
 *
 * <SideSheet sideSheetOpen={isSideSheetOpen}
 *   className={style.className}
 *   menuItems={menuItems}
 *   selectedIndex={selectedIndex}>
 *   {sideSheetContent}
 *  </SideSheet>
 *
 * ```
 */
export const SideSheetArrow = ({
  onClick,
  isSideSheetExpanded = false
}: SideSheetArrowTypes) => {
  return (
    <div style={{height: '100%', cursor: 'pointer', transition: 'all 0.3s ease'}} onClick={onClick}>
      <svg width="20" height="48" viewBox="0 0 20 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        {isSideSheetExpanded ? (
          <>
            <path d="M-3.8147e-06 48H20L20 0L-3.8147e-06 1.74845e-06V48Z" fill="#E9E9E9"/>
            <path d="M12 30L6.1996 24.1875L12 18.375V30Z" fill="#4F4F4F"/>
          </>
        ) : (
          <>
            <path d="M20 48L-4.52995e-06 48L-3.3366e-07 -2.10608e-06L20 -3.57628e-07L20 48Z" fill="#E9E9E9"/>
            <path d="M8 30L13.8004 24.1875L8 18.375L8 30Z" fill="#4F4F4F"/>
          </>
        )}
      </svg>
    </div>
  );
};

export default SideSheetArrow;
